import httpClient from "./httpClient";

const HospitalFacilityService = {
  async findAll(isActive) {
    return await httpClient.get("/hospital-facility", {
      params: isActive !== undefined ? { isActive } : {},
    });
  },

  async findById(id) {
    return await httpClient.get(`/hospital-facility/${id}`);
  },

  async create(entity) {
    return await httpClient.post("/hospital-facility", entity);
  },

  async update(id, entity) {
    return await httpClient.put(`/hospital-facility/${id}`, entity);
  },
};

export default HospitalFacilityService;
